module.exports = __webpack_public_path__ + "img/small.9a614472.jpg";